export default {
  articleUpdateDate: {
    id: 'article_update_date',
    defaultMessage: 'Updated on {date}',
  },
} as const
